import React from "react";
import NomenclaturePage from "./NomenclaturePage";
import useNomenclature from "./useNomenclature";

function Nomenclature() {
  return <NomenclaturePage {...useNomenclature()} />;
}

export default Nomenclature;
